import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

import * as ActionTypes from "../../actions/actionTypes";
import * as ControlPanelActions from "../../actions/controlPanelActions";
import * as AppConfigActions from "../../actions/appConfigActions";
import * as constants from "../../constants";

const saveAppConfigLogic = createLogic({
	type: ActionTypes.SAVE_APP_CONFIG,
	process({ getState, action }, dispatch, done) {
		dispatch(ControlPanelActions.showLoading());

		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				let api = axios.create({
					baseURL: constants.BASE_API_URL,
					timeout: 20000,
					headers: { Authorization: "Bearer " + token },
				});
				api.put(`/apps/${action.appKey}/config`, action.values)
					.then(res => {
						dispatch(ControlPanelActions.hideLoading());
						dispatch(ControlPanelActions.displayQuickMessage("App Config Saved"));
						dispatch(AppConfigActions.saveAppConfigSuccess(res.data));
						action.submitCallback(true, res);
						done();
					})
					.catch(error => {
						dispatch(ControlPanelActions.displayError(error.message));
						dispatch(AppConfigActions.saveAppConfigSuccess(error));
						action.submitCallback(false, error);
						done();
					});
			});
	},
});

export default [saveAppConfigLogic];
